import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SidebarMenu from './components/SidebarMenu';
import Home from './components/Home';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import UpdateMainMeter from './components/UpdateMainMeter';
import MainMeterList from './components/MainMeterList';
import 'bootstrap/dist/css/bootstrap.min.css';
import AddMainMeter from './components/AddMainMeter';
import SubMeterList from './components/SubMeterList';
import AddSubMeter from './components/AddSubMeter';
import UpdateSubMeter from './components/UpdateSubMeter';

import AddInvoice from './components/AddInvoice.js';
import InvoiceList from './components/InvoiceList.js';
import UpdateInvoice from './components/UpdateInvoice.js';

import MeterReadingList4Timeline from './components/MeterReadingList4Timeline.js';
import MeterReadingList from './components/MeterReadingList.js';
import AddMeterReading from './components/AddMeterReading.js';
import UpdateMeterReading from './components/UpdateMeterReading.js';

import AllocateInvoice from './components/InvoiceAllocation/AllocateInvoice.js';
import FreeConsumptionCalculator from './components/Rating/FreeConsumptionCalculator.js';
import FreeConsumptionFlow from './components/Rating/FreeConsumptionFlow.js';
import FreeConsumptionStepper from './components/Rating/FreeConsumptionStepper.js';
import RatingSummaryPage from './components/InvoiceAllocation/RatingSummaryPage.js';

import { CircularProgress, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { auth } from './firebase';
import './App.css';
import Header from './components/Header.js';
import theme from './components/theme';
import SiteService from './components/SiteService';
import PrivacyPolicy from './components/PrivacyPolicy';
import Support from './components/Support';
import Terms from './components/TermsPage.js';
import DeleteAccountPage from './components/DeleteAccountInfo.js';
import ElectricityBillCalculatorPage from './components/ElectricityBillCalculatorPage.js';
import PageMetadata from './components/PageMetadata.js';

function App() {
    const [user, setUser] = useState(null);
    const [preparationLevel, setPreparationLevel] = useState(null); // 🔹 Yeni state
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                setUser(user);

                try {
                    const response = await SiteService.getPreparationStatus();
                    setPreparationLevel(response.data.preparationLevel);
                } catch (error) {
                    console.error("Hazırlık durumu alınamadı:", error);
                    setPreparationLevel(0); // fallback olarak sıfır
                }
            } else {
                setUser(null);
                setPreparationLevel(null);
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <PageMetadata />
                {user ? (
                    <>
                        <Header
                            isMobile={isMobile}
                            isSidebarOpen={isSidebarOpen}
                            toggleSidebar={toggleSidebar}
                            user={user}
                        />
                        <div
                            style={{
                                display: 'flex',
                                paddingTop: '56px', // header yüksekliği
                            }}
                        >
                            <SidebarMenu
                                isOpen={isSidebarOpen}
                                isMobile={isMobile}
                                toggleSidebar={toggleSidebar}
                            />
                            <div
                                style={{
                                    padding: '16px',
                                    flex: 1,
                                    width: '100%',
                                    transition: 'margin 0.3s ease-in-out',
                                }}
                            >                                <Routes>
                                    {/* 🔹 Dinamik yönlendirme */}
                                    <Route path="/" element={
                                        preparationLevel === null
                                            ? <div style={{ display: 'flex', justifyContent: 'center', padding: 50 }}><CircularProgress /></div>
                                            : preparationLevel === 5
                                                ? <Navigate to="/invoices" />
                                                : <Home />
                                    } />
                                    <Route path="/landing" element={<Navigate to="/" />} />
                                    <Route path="/add-main-meter" element={<AddMainMeter />} />
                                    <Route path="/update-main-meter/:mainMeterId" element={<UpdateMainMeter />} />
                                    <Route path="/main-meters" element={<MainMeterList />} />
                                    <Route path="/sub-meters/:mainMeterId" element={<SubMeterList />} />
                                    <Route path="/add-sub-meter/:mainMeterId" element={<AddSubMeter />} />
                                    <Route path="/update-sub-meter/:mainMeterId/:subMeterId" element={<UpdateSubMeter />} />
                                    <Route path="/add-invoice/:mainMeterId?" element={<AddInvoice />} />
                                    <Route path="/update-invoice/:mainMeterId/:invoiceId" element={<UpdateInvoice />} />
                                    <Route path="/invoices/:mainMeterId?" element={<InvoiceList />} />
                                    <Route path="/meter-readings/:mainMeterId?" element={<MeterReadingList />} />
                                    <Route path="/meter-reading-list-timeline/:mainMeterId?" element={<MeterReadingList4Timeline />} />
                                    <Route path="/add-meter-reading/:mainMeterId?" element={<AddMeterReading />} />
                                    <Route path="/update-meter-reading/:mainMeterId/:subMeterId/:meterReadingId" element={<UpdateMeterReading />} />
                                    <Route path="/allocate-invoice/:mainMeterId?" element={<AllocateInvoice />} />
                                    <Route path="/free-rating/" element={<FreeConsumptionCalculator />} />
                                    <Route path="/free-rating-flow/" element={<FreeConsumptionFlow />} />
                                    <Route path="/free-rating-stepper/" element={<FreeConsumptionStepper />} />
                                    <Route path="/elektrik-faturasi-hesaplama" element={<ElectricityBillCalculatorPage />} />
                                    <Route path="/rating-summary/:mainMeterId/:invoiceId" element={<RatingSummaryPage />} />
                                    <Route path="/privacy" element={<PrivacyPolicy />} />
                                    <Route path="/support" element={<Support />} />
                                    <Route path="/terms" element={<Terms />} />
                                    <Route path="/delete-account" element={<DeleteAccountPage />} />
                                </Routes>
                            </div>
                        </div>
                    </>
                ) : (
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/landing" element={<Navigate to="/" replace />} />
                        <Route path="/elektrik-faturasi-hesaplama" element={<ElectricityBillCalculatorPage />} />
                        <Route path="/login" element={<Navigate to="/" replace />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/support" element={<Support />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/delete-account" element={<DeleteAccountPage />} />
                    </Routes>
                )}
            </Router>
        </ThemeProvider>
    );
}

export default App;
